import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewVariant } from "@/common/ts/layout";
import { DamageCostEvaluationDto } from "@/core/api/generated/v1";

import EntityInboxList from "../../../Chat/ListView/EntityInboxList";

interface Props {
  damageCostEvaluation: DamageCostEvaluationDto;
}

export default function InboxTabContent({ damageCostEvaluation }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock spacing={1} sx={{ p: 0, borderRadius: "inherit" }}>
        <EntityInboxList
          displayProps={{
            header: false,
            viewVariant: ViewVariant.Tab,
          }}
          defaultValues={{
            damageCostEvaluationId: damageCostEvaluation.id!,
          }}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
